import * as Yup from 'yup'
import { fieldsValidation } from 'primsell-shared-layer/utils'

export const burnFormSchema = () =>
  Yup.object().shape({
    firstName: Yup.string().required(fieldsValidation.REQUIRED).nullable(),
    lastName: Yup.string().required(fieldsValidation.REQUIRED).nullable(),
    email: Yup.string().email('Invalid email format').required(fieldsValidation.REQUIRED).nullable(),
    agree: Yup.boolean()
      .oneOf([true], 'You must agree to the terms and conditions')
      .required(fieldsValidation.REQUIRED),
  })
